<template>
  <div>
    <v-select
      :items="products"
      v-model="selectedProduct"
      item-value="id"
      item-text="name"
      placeholder="Produkt"
      hint="Produkt"
    />
    <v-select
      :items="orders"
      v-model="selectedOrder"
      item-value="id"
      item-text="name"
      placeholder="Auftrag"
      hint="Auftrag"
    />
    <v-select
      :items="activities"
      v-model="selectedActivity"
      item-value="id"
      item-text="name"
      placeholder="Tätigkeit"
      hint="Tätigkeit"
      required
      :rules="projectRules"
    />
  </div>
</template>

<script>
export default {
  name: 'ProjectSelect',
  props: {
    value: Object,
    validationsOff: {
      type: Boolean,
      default: false,
    },
    hideInactive: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    products() {
      return this.$store.state.products.filter(x => !this.hideInactive || x.isActive);
    },
    orders() {
      if (!this.selectedProduct) {
        return [];
      }

      const selectedProduct = this.products.find(x => x.id === this.selectedProduct);

      if (selectedProduct) {
        return selectedProduct.orders.filter(x => !this.hideInactive || x.isActive);
      }

      return [];
    },
    activities() {
      if (!this.selectedOrder) {
        return [];
      }

      const selectedOrder = this.orders.find(x => x.id === this.selectedOrder);
      if (selectedOrder) {
        return selectedOrder.activities.filter(x => !this.hideInactive || x.isActive);
      }

      return [];
    },
    selectedProduct: {
      get() {
        return this.value ? this.value.product : null;
      },
      set(v) {
        this.$emit('input', { product: v, order: this.selectedOrder, activity: this.selectedActivity });
      }
    },
    selectedOrder: {
      get() {
        return this.value ? this.value.order : null;
      },
      set(v) {
        this.$emit('input', { product: this.selectedProduct, order: v, activity: this.selectedActivity });
      }
    },
    selectedActivity: {
      get() {
        return this.value ? this.value.activity : null;
      },
      set(v) {
        this.$emit('input', { product: this.selectedProduct, order: this.selectedOrder, activity: v });
      }
    }
  },
  methods: {
    clear() {
      this.$emit('input', null);
    },
    isValid() {
      return this.selectedProduct && this.selectedOrder && this.selectedActivity;
    },
  },
  data() {
    return {
      projectRules: [
        v => (this.validationsOff || !!v) || 'Bitte wählen Sie ein Projekt, Auftrag und Tätigkeit aus',
      ],
    };
  },
};
</script>
